import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { image } from 'services'
import { Button, IonIcon, Modal } from 'controls'

import { msgModal } from './style'

const ReportSentMessage = ({ handleFinish, openModal }) => {
  return (
    <Modal isOpen={openModal} onClose={() => handleFinish}>
      <div className="message-container">
        <h3>
          <strong>¡Gracias por envíar tu reporte!</strong>
        </h3>

        <p>Trabajaremos en darte una solución lo más pronto posible.</p>
      </div>
      <div className="image-bell-success">
        <img src={image('/icons/icon-report.png')} alt="Message Sent" />
      </div>
      <div className="finish-button">
        <Button
          onClick={handleFinish}
          color="primary"
          style={{
            width: '40%'
          }}
        >
          Finalizar
        </Button>
      </div>

      <style jsx>{msgModal}</style>
    </Modal>
  )
}

ReportSentMessage.propTypes = {
  handleFinish: PropTypes.func.isRequired,
  openModal: PropTypes.bool.isRequired
}

export default ReportSentMessage
